export class LocationsFakeDb {
  public static locations = [
    {
      id: "locations",
      plane: {},
    },
  ];
}
